
import { VTabsSlider } from "vuetify/lib";

export default VTabsSlider.extend({});
